var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { AppBar as MuiAppBar, styled, Toolbar, } from '@mui/material';
import React from 'react';
import AppName from '../AppName';
var SMuiAppBar = styled(MuiAppBar, {
    shouldForwardProp: function (prop) { return prop !== 'popout'; },
    name: 'MuiAppBar',
    overridesResolver: function (_a) {
        var popout = _a.popout, theme = _a.theme;
        return popout && [theme.components.MuiAppBar.customOverrides.popout];
    },
})({});
var AppHeader = function (_a) {
    var appName = _a.appName, appNameProps = _a.appNameProps, popout = _a.popout, toolbarProps = _a.toolbarProps, children = _a.children, props = __rest(_a, ["appName", "appNameProps", "popout", "toolbarProps", "children"]);
    return (React.createElement(SMuiAppBar, __assign({}, __assign({ popout: popout }, props)),
        React.createElement(Toolbar, __assign({}, toolbarProps),
            appName && React.createElement(AppName, __assign({ name: appName }, appNameProps)),
            children)));
};
export default AppHeader;
